import { useState } from 'react'

const DEMO = {
  name: 'La Belle Table',
  description: 'A cozy bistro with fresh seasonal dishes.',
  primaryColor: '#2d6a4f',
  heroTitle: 'Fresh, Local, Delicious',
  heroSubtitle: 'Seasonal ingredients, crafted with care.',
  logo: null,
  contact: {},
  socialMedia: {},
  menu: [],
}

function NavBar({ restaurant }) {
  const [open, setOpen] = useState(false)
  const r = restaurant || DEMO
  const color = r.primaryColor || '#2d6a4f'

  return (
    <nav style={{ background: '#fff', borderBottom: '1px solid #e5e7eb', position: 'sticky', top: 0, zIndex: 100 }}>
      <div style={{ maxWidth: 1200, margin: '0 auto', padding: '0 24px', height: 64, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          {r.logo
            ? <img src={r.logo} alt={r.name} style={{ width: 40, height: 40, borderRadius: '50%', objectFit: 'cover' }} />
            : <div style={{ width: 40, height: 40, borderRadius: '50%', background: color, display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', fontWeight: 700, fontSize: 14 }}>
                {r.name.split(' ').map(w => w[0]).join('').slice(0, 2).toUpperCase()}
              </div>
          }
          <span style={{ fontSize: 20, fontWeight: 700, color: '#111' }}>{r.name}</span>
        </div>

        <div style={{ display: 'flex', gap: 32, alignItems: 'center' }}>
          <a href="#" style={{ color: '#374151', textDecoration: 'none', fontSize: 15, fontWeight: 500 }}>Home</a>
          <a href="#menu" style={{ color: '#374151', textDecoration: 'none', fontSize: 15, fontWeight: 500 }}>Menu</a>
          <a href="#contact" style={{ color: '#374151', textDecoration: 'none', fontSize: 15, fontWeight: 500 }}>Contact</a>
          <a href="#menu" style={{ background: color, color: '#fff', padding: '10px 24px', borderRadius: 8, textDecoration: 'none', fontSize: 15, fontWeight: 600 }}>
            Order Now
          </a>
        </div>
      </div>

      <style>{`
        @media (max-width: 768px) {
          nav > div > div:last-child { display: none !important; }
        }
      `}</style>
    </nav>
  )
}

function Hero({ restaurant }) {
  const r = restaurant || DEMO
  const color = r.primaryColor || '#2d6a4f'
  const heroImages = r.menu?.filter(i => i.imageUrl).map(i => i.imageUrl).slice(0, 3) || []

  return (
    <section style={{ background: 'linear-gradient(135deg, #f9fafb 0%, #f3f4f6 100%)', padding: '80px 24px' }}>
      <div style={{ maxWidth: 1200, margin: '0 auto', display: 'flex', alignItems: 'center', gap: 60, flexWrap: 'wrap' }}>
        <div style={{ flex: '1 1 360px' }}>
          <span style={{ display: 'inline-block', background: `${color}15`, color, padding: '6px 16px', borderRadius: 100, fontSize: 13, fontWeight: 600, marginBottom: 20 }}>
            Welcome
          </span>
          <h1 style={{ fontSize: 52, fontWeight: 800, color: '#111', lineHeight: 1.15, margin: '0 0 20px' }}>
            {r.heroTitle || r.name}
          </h1>
          <p style={{ fontSize: 18, color: '#6b7280', lineHeight: 1.7, margin: '0 0 36px', maxWidth: 480 }}>
            {r.heroSubtitle || r.description || 'Discover our carefully crafted dishes.'}
          </p>
          <a href="#menu" style={{ display: 'inline-flex', alignItems: 'center', gap: 8, background: color, color: '#fff', padding: '16px 36px', borderRadius: 10, fontSize: 16, fontWeight: 700, textDecoration: 'none' }}>
            View Menu →
          </a>
        </div>

        {heroImages.length > 0 && (
          <div style={{ flex: '1 1 300px', display: 'grid', gridTemplateColumns: heroImages.length > 1 ? '1fr 1fr' : '1fr', gap: 12 }}>
            {heroImages.slice(0, 4).map((src, i) => (
              <img key={i} src={src} alt="dish" style={{ width: '100%', aspectRatio: '1', objectFit: 'cover', borderRadius: 16, boxShadow: '0 4px 20px rgba(0,0,0,0.08)' }} />
            ))}
          </div>
        )}
      </div>
    </section>
  )
}

function MenuGrid({ restaurant }) {
  const r = restaurant || DEMO
  const color = r.primaryColor || '#2d6a4f'
  const items = r.menu?.length > 0 ? r.menu : []

  const categories = ['All', ...new Set(items.map(i => i.category).filter(Boolean))]
  const [active, setActive] = useState('All')

  const filtered = active === 'All' ? items : items.filter(i => i.category === active)

  return (
    <section id="menu" style={{ padding: '80px 24px', background: '#fff' }}>
      <div style={{ maxWidth: 1200, margin: '0 auto' }}>
        <div style={{ textAlign: 'center', marginBottom: 48 }}>
          <h2 style={{ fontSize: 40, fontWeight: 800, color: '#111', margin: '0 0 12px' }}>
            Our Menu
          </h2>
          <p style={{ fontSize: 16, color: '#6b7280', margin: 0 }}>
            Made fresh daily with quality ingredients
          </p>
        </div>

        {categories.length > 1 && (
          <div style={{ display: 'flex', justifyContent: 'center', gap: 10, marginBottom: 40, flexWrap: 'wrap' }}>
            {categories.map(cat => (
              <button
                key={cat}
                onClick={() => setActive(cat)}
                style={{
                  padding: '8px 22px',
                  borderRadius: 100,
                  border: `2px solid ${active === cat ? color : '#e5e7eb'}`,
                  background: active === cat ? color : 'transparent',
                  color: active === cat ? '#fff' : '#374151',
                  fontWeight: 600,
                  fontSize: 14,
                  cursor: 'pointer',
                }}
              >
                {cat}
              </button>
            ))}
          </div>
        )}

        {filtered.length === 0 && (
          <p style={{ textAlign: 'center', color: '#9ca3af', fontSize: 16 }}>No items yet.</p>
        )}

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: 28 }}>
          {filtered.map((item, i) => (
            <div key={i} style={{ background: '#f9fafb', borderRadius: 16, overflow: 'hidden', border: '1px solid #e5e7eb' }}>
              {item.imageUrl
                ? <img src={item.imageUrl} alt={item.name} style={{ width: '100%', height: 200, objectFit: 'cover' }} />
                : <div style={{ height: 200, background: '#e5e7eb', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 56 }}>
                    {item.emoji || '🍽️'}
                  </div>
              }
              <div style={{ padding: 20 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 8 }}>
                  <h3 style={{ fontSize: 17, fontWeight: 700, color: '#111', margin: 0, flex: 1, marginRight: 12 }}>{item.name}</h3>
                  <span style={{ fontSize: 16, fontWeight: 700, color, whiteSpace: 'nowrap' }}>
                    DA {item.price?.toFixed ? item.price.toFixed(0) : item.price}
                  </span>
                </div>
                {item.description && (
                  <p style={{ fontSize: 14, color: '#6b7280', margin: '0 0 16px', lineHeight: 1.5 }}>{item.description}</p>
                )}
                <button style={{ width: '100%', padding: '10px 0', borderRadius: 8, border: `2px solid ${color}`, background: 'transparent', color, fontWeight: 600, fontSize: 14, cursor: 'pointer' }}>
                  Add to Order
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

function ContactSection({ restaurant }) {
  const r = restaurant || DEMO
  const color = r.primaryColor || '#2d6a4f'

  return (
    <section id="contact" style={{ background: '#f9fafb', padding: '80px 24px', borderTop: '1px solid #e5e7eb' }}>
      <div style={{ maxWidth: 700, margin: '0 auto', textAlign: 'center' }}>
        <h2 style={{ fontSize: 36, fontWeight: 800, color: '#111', margin: '0 0 16px' }}>Find Us</h2>
        {r.contact?.address && <p style={{ fontSize: 16, color: '#6b7280', marginBottom: 8 }}>{r.contact.address}</p>}
        {r.contact?.phone && <p style={{ fontSize: 16, color: '#6b7280', marginBottom: 8 }}>📞 {r.contact.phone}</p>}
        {r.contact?.email && <p style={{ fontSize: 16, color: '#6b7280', marginBottom: 24 }}>✉️ {r.contact.email}</p>}

        {(r.socialMedia?.instagram || r.socialMedia?.facebook) && (
          <div style={{ display: 'flex', justifyContent: 'center', gap: 16 }}>
            {r.socialMedia.instagram && (
              <a href={r.socialMedia.instagram} style={{ background: color, color: '#fff', padding: '10px 24px', borderRadius: 8, textDecoration: 'none', fontWeight: 600, fontSize: 14 }}>
                Instagram
              </a>
            )}
            {r.socialMedia.facebook && (
              <a href={r.socialMedia.facebook} style={{ background: color, color: '#fff', padding: '10px 24px', borderRadius: 8, textDecoration: 'none', fontWeight: 600, fontSize: 14 }}>
                Facebook
              </a>
            )}
          </div>
        )}
      </div>
    </section>
  )
}

function SmoothFooter({ restaurant }) {
  const r = restaurant || DEMO
  return (
    <footer style={{ background: '#111', color: '#9ca3af', textAlign: 'center', padding: '24px', fontSize: 14 }}>
      © {new Date().getFullYear()} {r.name}. Powered by Eatbridge.
    </footer>
  )
}

export default function SmoothTemplate({ restaurant }) {
  return (
    <div style={{ fontFamily: "'Inter', 'Segoe UI', sans-serif", margin: 0, padding: 0 }}>
      <NavBar restaurant={restaurant} />
      <Hero restaurant={restaurant} />
      <MenuGrid restaurant={restaurant} />
      <ContactSection restaurant={restaurant} />
      <SmoothFooter restaurant={restaurant} />
    </div>
  )
}
